import api from "../api/api";

export const authService = {
    // Register new user
    register: async (userData) => {
        try {
            const response = await api.post("customer/register", {
                full_name: userData.fullName,
                email: userData.email,
                password: userData.password,
                password_confirmation: userData.confirmPassword,
                type: "regular"
            });
            return response.data;
        } catch (error) {
            console.error("Registration failed:", error);
            throw error;
        }
    },

    // Login user
    login: async (credentials) => {
        try {
            const response = await api.post("customer/login", {
                email: credentials.email,
                password: credentials.password
            });
            return response.data;
        } catch (error) {
            console.error("Login failed:", error);
            throw error;
        }
    },

    // Logout user
    logout: async () => {
        try {
            // If your API has logout endpoint
            const response = await api.post("customer/logout");

            // Clear local storage
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            localStorage.setItem("userLogin", "False");

            return { success: true };
        } catch (error) {
            console.error("Logout failed:", error);
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            localStorage.setItem("userLogin", "False");
            throw error;
        }
    },

    // Get user profile data
    getProfile: async () => {
        try {
            const response = await api.get("customer/profile");
            return response.data;
        } catch (error) {
            console.error("Failed to fetch user profile:", error);
            throw error;
        }
    },

    // Update user profile
    updateProfile: async (profileData) => {
        try {
            const response = await api.put("customer/profile", profileData);
            return response.data;
        } catch (error) {
            console.error("Failed to update profile:", error);
            throw error;
        }
    },

    // Get customer orders
    getOrders: async () => {
        try {
            const response = await api.get("customer/orders");
            return response.data;
        } catch (error) {
            console.error("Failed to fetch orders:", error);
            throw error;
        }
    },

    // Get specific order details
    getOrderDetails: async (orderId) => {
        try {
            const response = await api.get(`customer/orders/${orderId}`);
            return response.data;
        } catch (error) {
            console.error("Failed to fetch order details:", error);
            throw error;
        }
    },

    // Get stored user data
    getCurrentUser: () => {
        const user = localStorage.getItem("user");
        return user ? JSON.parse(user) : null;
    },

    // Get stored token
    getToken: () => {
        return localStorage.getItem("token");
    },

    // Check if user is authenticated
    isAuthenticated: () => {
        return !!localStorage.getItem("token");
    },

    // Check login status
    isLoggedIn: () => {
        const userLogin = localStorage.getItem("userLogin");
        const token = localStorage.getItem("token");
        const user = localStorage.getItem("user");

        return userLogin === "True" && token && user;
    }
};

// Add token to all requests automatically
api.interceptors.request.use(
    (config) => {
        const token = authService.getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default authService;